import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { Organization } from '../models/organization';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { PagerService } from '../services/pager.service';

import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.css']
})
export class OrganizationsComponent implements OnInit {
  public organizations: Organization[] = [];
  public error: string;

  private filteredOrganizations: any;

  private allItems: any[];
  pager: any = {};
  pagedItems: any[];

  public screenWidth: number = window.innerWidth;

  constructor(private globalService: GlobalService, private router: Router, private modalService: ModalService, private pagerService: PagerService, private loadingService: LoadingService) {
    modalService.modal$.subscribe((modal) => {
      // console.log("Ran in advisor component - modal subscription");
      // console.log(modal.modalName);
      if (modal.modalName == 'create-organizationClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getOrganizations();
      }
    });
  }

  ngOnInit() {

    if(localStorage.getItem('roleId') != '2' && localStorage.getItem('roleId') != '1'){
      this.router.navigate(['/home']);
    }else{

      this.getOrganizations();
    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
        return;
    }

    // get pager object from service
    // this.pager = this.pagerService.getPager(this.allItems.length, page);
    this.pager = this.pagerService.getPager(this.filteredOrganizations.length, page);

    // get current page of items
    this.pagedItems = this.filteredOrganizations.slice(this.pager.startIndex, this.pager.endIndex + 1);
    // console.log(this.pagedItems);
  }

  getOrganizations() {
    this.loadingService.isLoading(true);
    this.globalService.getOrganizationsData()
      .subscribe(
      organizations => {
         // this.organizations = organizations;
        this.allItems = organizations;
        //this.setPage(1);

        this.filteredOrganizations = this.allItems;

        this.filteredOrganizations = this.allItems.sort(function (a, b) {
          return parseInt(b.ID) - parseInt(a.ID);
        });

        this.filteredOrganizations.map((org) => {
          if (org.Phone.indexOf("-") == -1 && org.Phone.indexOf("(") == -1 && org.Phone.indexOf(")") == -1)
            org.Phone = this.onPhoneInputChange(org.Phone);
        });

        this.setPage(1);
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error
        this.loadingService.isLoading(false);
      });
  }

  onPhoneInputChange(event) {
    let newVal = event.replace(/\D/g, '');
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, 10);
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }
    //this.ngControl.valueAccessor.writeValue(newVal);
    return newVal;
  }


  handleOrganizationMetrics(e, organization) {
    //
  }

  // handleCreateOrganizationModal() {
  //   this.modalService.add('create-organization', { ID: 0 });
  // }

  // handleEditOrganizationModal(e, organization) {
  //   this.modalService.add('edit-organization', { ID: organization.ID });
  // }

  filterItem(value) {
    this.filteredOrganizations = Object.assign([], this.allItems).filter(
      org => {
        return (org.Name).toLowerCase().includes(value.toLowerCase()) || (org.Phone).toLowerCase().includes(value.toLowerCase()) || (org.Email).toLowerCase().includes(value.toLowerCase())
      }
    );

    if (!this.filteredOrganizations.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }
}
